import React, { Component } from "react";
import { Card, CardContent } from "../../ui/card";
import { Button } from "../../ui/button";
import { FileText, Pencil, AlertCircle } from 'lucide-react';

class PricingSheetCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: '',
            userName: '',
            iframeError: false,
        }
    }
    
    componentDidMount() {
        this.handleImageOpen = this.handleImageOpen.bind(this)
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({ userId: Usermeta_Data.split(':')[0], userName: Usermeta_Data.split(':')[1] })
    }
    
    handleImageOpen(filePath) {
        window.open(filePath, '_blank');
    }
    
    editSheet(e) {
        e.stopPropagation()
        this.props.editSheet()
    }
    
    handleIframeError = () => {
        this.setState({ iframeError: true });
    }
    
    render() {
        return (
            <Card 
                className="group overflow-hidden transition-all hover:shadow-lg cursor-pointer" 
                onClick={() => this.handleImageOpen(this.props.sheetData?.filePath)}
            >
                <div className="relative aspect-[4/5] bg-gray-50">
                    {!this.state.iframeError ? (
                        <iframe 
                            src={this.props.sheetData.filePath}
                            className="w-full h-full pointer-events-none"
                            title={this.props.sheetData.fileName}
                            onError={this.handleIframeError}
                        />
                    ) : (
                        <div className="flex flex-col items-center justify-center h-full gap-2">
                            <AlertCircle className="h-12 w-12 text-gray-400" />
                            <p className="text-sm text-gray-500 font-medium">File not found</p>
                        </div>
                    )}
                    
                    <div className="absolute inset-0 flex items-center justify-center bg-black/0 group-hover:bg-black/10 transition-colors pointer-events-none">
                        <div className="bg-brand-accent rounded-full p-3 group-hover:scale-110 transition-transform">
                            <FileText className="h-6 w-6 text-white" />
                        </div>
                    </div>
                    
                    <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                        <Button 
                            variant="secondary" 
                            size="icon" 
                            className="h-8 w-8 bg-white hover:bg-gray-100"
                            onClick={this.editSheet.bind(this)}
                        >
                            <Pencil className="h-4 w-4" />
                        </Button>
                    </div>
                </div>
                
                <CardContent className="p-3">
                    <h4 className="text-md font-bold text-brand-dark truncate" title={this.props.sheetData.fileName}>
                        {this.props.sheetData.fileName}
                    </h4>
                </CardContent>
            </Card>
        )
    }
}

export default PricingSheetCard;
